import "core-js/modules/es.number.constructor";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import Vue from 'vue';
var VIPICON = {
  1: 'https://puui.qpic.cn/vupload/0/20190428_VIP_1_2x.png/0',
  2: 'https://puui.qpic.cn/vupload/0/20190428_VIP_2_2x.png/0',
  3: 'https://puui.qpic.cn/vupload/0/20190428_VIP_3_2x.png/0',
  4: 'https://puui.qpic.cn/vupload/0/20190428_VIP_4_2x.png/0',
  5: 'https://puui.qpic.cn/vupload/0/20190428_VIP_5_2x.png/0',
  6: 'https://puui.qpic.cn/vupload/0/20190428_VIP_6_2x.png/0',
  7: 'https://puui.qpic.cn/vupload/0/20190428_VIP_7_2x.png/0',
  8: 'https://vfiles.gtimg.cn/vupload/20200616/c2756a1592295933410.png'
};

function _dateFormat(val) {
  var fmt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yyyy-MM-dd';
  var date = new Date(val); // eslint-disable-next-line no-restricted-globals

  if (isNaN(date.getDate())) return '';
  var o = {
    'M+': date.getMonth() + 1,
    // 月份
    'd+': date.getDate(),
    // 日
    'h+': date.getHours(),
    // 小时
    'm+': date.getMinutes(),
    // 分
    's+': date.getSeconds(),
    // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3),
    // 季度
    S: date.getMilliseconds() // 毫秒

  };

  if (/(y+)/.test(fmt)) {
    // eslint-disable-next-line no-param-reassign
    fmt = fmt.replace(RegExp.$1, "".concat(date.getFullYear()).substr(4 - RegExp.$1.length));
  } // eslint-disable-next-line no-restricted-syntax


  for (var k in o) {
    if (new RegExp("(".concat(k, ")")).test(fmt)) {
      // eslint-disable-next-line no-param-reassign
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : "00".concat(o[k]).substr("".concat(o[k]).length));
    }
  }

  return fmt;
}

Vue.mixin({
  filters: {
    priceFormat: function priceFormat(val) {
      return val ? +Number(val / 100) : val;
    },
    levelFormat: function levelFormat(val) {
      return VIPICON[val];
    },
    dateFormat: function dateFormat(val, fmt) {
      return _dateFormat(val, fmt);
    }
  }
});